import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

export const CARD_WIDTH = 13.625;
export const CARD_MAX_HEIGHT = 47.1925;

export const StyledCard = styled(Box)(({ theme }) => ({
  width: theme.spacing(CARD_WIDTH),
  maxHeight: theme.spacing(CARD_MAX_HEIGHT),
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1.5),
  overflow: 'hidden',
  flexShrink: 0,
}));

export const ImageContainer = styled(Box)({
  position: 'relative',
});

export const BadgeSkeleton = styled(Skeleton)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(-1.25),
  right: theme.spacing(0.75),
  borderRadius: theme.spacing(1),
}));

export const ContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.75),
  padding: theme.spacing(1.75, 0.75, 1, 0.75),
}));

export const FlexRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
}));

export const BrandLogoSkeleton = styled(Skeleton)({
  borderRadius: '50%',
});

export const TextLineSkeleton = styled(Skeleton)(({ theme }) => ({
  borderRadius: theme.spacing(0.5),
}));

export const SkeletonAddToBasketButton = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: '4px',
  right: '4px',
  width: '28px',
  height: '28px',
  background: theme.palette.common.mds_global_color_white,
  borderRadius: '8px',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
  isolation: 'isolate',
  '& svg': {
    display: 'block',
    width: '16px',
    height: '16px',
    flexShrink: 0,
  },
}));
